<template>
<!-- srchTop_wrap -->
<form class="srchTop_wrap" :class="{ extend : isExtend }">
    <article class="srch_basic">
        <dl class="dl_search">
            <dd class="clearable" data-input-type="input">
                <input  type="text"
                        class="text_input w100p"
                        maxlength="30"
                        :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH')"
                        v-model.trim="selectedModel"
                        @keyup.enter.stop="handleSearch"
                        v-clearable
                >
            </dd>
            <dd class="btn">
                <a href="javascript:" class="btn_srch" @click="handleSearch">
                    {{ $t('FIELD.GLOBAL.SEARCH') }}
                </a>
            </dd>
        </dl>
        <!-- mobile_hide -->
        <div class="top_mobile">
            <category-combobox
                :searchPRD_CATEGORY_CD1="getSearchQueryCatCd1"
                :searchPRD_CATEGORY_CD2="getSearchQueryCatCd2"
                :searchPRD_CATEGORY_CD3="getSearchQueryCatCd3"
                :menuGroupDetailCd="getCondition.MENU_GROUP_DETAIL_CD"
                :hhpYn="getCondition.HHP_YN"
                @categoryCode="setCategoryParam"
            />
        </div>
        <!-- //mobile_hide -->
    </article>
    <article class="srch_detail">
        <div class="list_wrap">
            <header>
                <h3>{{ $t('FIELD.KNOWLEDGE.SEARCH.QUICKCATEGORY') }}</h3>
            </header>
            <ul class="ul_list">
                <!-- myCategory top 3 -->
                <li v-for="cat in quickCategoryList">
                    <a
                        href="javascript:"
                        @click="setQuickCategory(cat.category1, cat.category2, cat.category3)"
                    >{{ cat.categoryNm }}</a>
                </li>
            </ul>
        </div>
        <dl class="dl_input">
            <dt>{{$t('FIELD.GLOBAL.DATE')}}</dt>
            <dd data-input-type="date">
                <fieldset class="ui_fieldset">
                    <span class="date-wrap">
                        <label>
                            <input id="fromDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.FROMDATE')">
                            <a href="javascript:" class="in_btn" id="icoFromDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                        </label>
                        <div id="from-picker-container" style="margin-top: -1px;"></div>
                    </span>
                    <em class="txt_space"></em>
                    <span class="date-wrap">
                        <label>
                            <input id="toDate" type="text" class="date_input w100p bg_white" readonly :placeholder="$t('FIELD.KNOWLEDGE.SEARCH.TODATE')">
                            <a href="javascript:" class="in_btn" id="icoToDate"><i class="ico_date"></i><span class="sr_only">{{ $t('FIELD.GLOBAL.DATE') }}</span></a>
                        </label>
                        <div id="to-picker-container" style="margin-top: -1px;"></div>
                    </span>
                </fieldset>
            </dd>
        </dl>
        <dl class="dl_select" v-if="isSymptom">
            <dt>{{ $t('FIELD.GLOBAL.SYMPTOM') }}</dt>
            <dd data-input-type="select">
                <select class="slt_white w30p" id="searchSYMPTOM_TYPE" v-model="selSymptomType" @change="changeSymptomType($event)">
                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                    <option v-if="searchSYMPTOM_TYPEList.length > 0"
                            v-for="item in searchSYMPTOM_TYPEList"
                            :key="item.code"
                            :value="item.code"
                    >{{item.codeName}}</option>
                </select>
                <select class="slt_white w30p" id="searchSYMPTOM_TYPE1" v-model="selSymptomType1">
                    <option value="" selected>{{ $t('FIELD.KNOWLEDGE.SEARCH.SELECTSYMPTOM') }}</option>
                    <option v-if="searchSYMPTOM_TYPE1List.length > 0"
                            v-for="item in searchSYMPTOM_TYPE1List"
                            :key="item.code"
                            :value="item.code"
                    >{{item.codeName}}</option>
                </select>
            </dd>
        </dl>
        <dl class="dl_select" v-if="isGuideDefect">
            <dt>{{ $t('FIELD.KNOWLEDGE.DEFECTTYPE') }}</dt>
            <dd data-input-type="select">
                <select class="slt_white w100p" id="defectType">
                    <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                    <option value="M">Common</option>
                    <option value="C">Call</option>
                    <option value="R">Repair</option>
                </select>
            </dd>
            <dt>{{ $t('FIELD.KNOWLEDGE.GUIDETYPE') }}</dt>
            <dd data-input-type="select">
                <select class="slt_white w100p" id="guideType">
                    <option value="" selected>{{$t('FIELD.GLOBAL.ALL')}}</option>
                    <option value="P">Parts Used</option>
                    <option value="S">S/W & Firmware</option>
                    <option value="A">Alternative Parts</option>
                    <option value="O">On Site Check Guide</option>
                    <option value="R">Repair Information & Tips</option>
                    <!-- C23030008966  서비스블레틴 신규 guide type 추가  ke01.liu 2023-04-07 begin -->
                    <option value="M">Manufacturing BOM Change</option>
                    <!-- C23030008966  서비스블레틴 신규 guide type 추가  ke01.liu 2023-04-07 end -->
                </select>
            </dd>
        </dl>
        <dl class="dl_input">
            <dt>{{ $t('FIELD.KNOWLEDGE.SEARCH.TITLEDESCSEARCH') }}</dt>
            <dd data-input-type="input">
                <input  type="text"
                        class="text_input"
                        id="searchTitle"
                        maxlength="200"
                        :placeholder="$t('FIELD.PLACEHOLDER.KNOWLEDGE.RESULTSEARCH')"
                        v-model.trim="searchTitle"
                        @keyup.enter.stop="handleSearch"
                        v-clearable
                >
            </dd>
        </dl>
    </article>
    <a  href="javascript:"
        class="btn_ico_srchBtm"
        :title="isExtend ? $t('BUTTON.GLOBAL.FOLD') : $t('BUTTON.GLOBAL.EXTEND')"
        @click="isExtend = !isExtend"
    >
        <span class="sr_only"></span>
    </a>
</form>
<!-- //srchTop_wrap -->
</template>

<script>
import 'tui-date-picker/dist/tui-date-picker.css';
import Vue                                  from 'vue';
import { mapGetters, mapActions }           from 'vuex';
import _                                    from 'lodash';
import $                                    from 'jquery';
import axios                                from 'axios';
import qs                                   from 'query-string';
import moment                               from 'moment';
import store                                from '@/vuex/store';
import SDLLocale                            from '@/mixin/SDLLocale';
import { SDLUtil, StringUtil, MenuUtil }    from '@/utils';
import DatePicker                           from '~c/DatePicker';
import { EventBus }                         from '@/utils/EventBus';
import CategoryComboBox                     from '~vb/common/CategoryComboBox';

import ExcelDownloadPopup                   from '~vb/common/ExcelDownloadPopup';

require('moment-jdateformatparser');

const MAX_DATE = new Date(2999,12,31),
      MIN_DATE = new Date(1900,1,1);

// Service Bulletin, Repair Tip, Call Guide, Repeated Repair Tip
const SYMPTOM_GROUP_CD = MenuUtil.getRepairMenuGroup;

// Service Bulletin, Service Bulletin (Local)
const GUIDE_DEFECT_GROUP_CD = MenuUtil.getGuideDefectGroup;

const fetchSymptomList = (codeCategoryId, categoryId, symptomType, symptom1) => axios.get(
        `${SDLUtil.API_URL}/basis/common/codeAjax.skp?`
      + `codeCategoryId=${codeCategoryId}`
      + `&categoryId=${categoryId}`
      + `&symptomType=${symptomType}`
      + `&symptom1=${symptom1}`
      + `&parentCode=1`
    );

export default {
    name : 'KnowledgeSearch',
    props: {
        boardId : { required: true },
        condition : { required: true }
    },
    data() {
        return {
            isLoading: true,
            isExtend: true,             // 20.06.10 초기 검색 영역은 펼쳐 놓기
            isSymptom: false,
            isGuideDefect: false,
            rangePicker: null,
            searchPrdCategory1: '',
            searchPrdCategory2: '',
            searchPrdCategory3: '',
            multi: 'N',
            selectedModel: '',
            selectedModelList: [],
            selSymptomType: '',
            selSymptomType1: '',
            searchSYMPTOM_TYPEList: [],
            searchSYMPTOM_TYPE1List: [],
            searchTitle: '',

            searchRange: -3,

            quickCategoryList: [],

            ORDER_COLUMN: '',
            ORDER_ASC: '',
            pageNo: 1
        }
    },
    computed: {
        ...mapGetters({
            locale: 'getLocale',
            storeParams: 'getParams'
        }),
        getBoardId()            { return this.boardId; },
        getCondition()          { return this.condition; },
        getSearchQueryCatCd1()  { return this.$route.query.searchPRD_CATEGORY_CD1 || ''; },
        getSearchQueryCatCd2()  { return this.$route.query.searchPRD_CATEGORY_CD2 || ''; },
        getSearchQueryCatCd3()  { return this.$route.query.searchPRD_CATEGORY_CD3 || ''; },
        getReSearch()           { return this.$route.query.reSearch || 'N'; },
        getPageNo()             { return this.pageNo; },

        getFromDate() {
            const boardParams = SDLUtil.getBoardSearchParams(this.getBoardId) || { searchParams: {} },
                  mFormat = localStorage.getItem('mDateFormat');    // moment dateformat
            if(typeof(boardParams.searchParams) !== 'undefined' && typeof(boardParams.searchParams.searchFromAddDt) !== 'undefined') {
                let date = boardParams.searchParams.searchFromAddDt;
                return moment(date, mFormat).toDate();

            } else {
                return null;
            }
        },
        getToDate() {
            const boardParams = SDLUtil.getBoardSearchParams(this.getBoardId) || { searchParams: {} },
                  mFormat = localStorage.getItem('mDateFormat');    // moment dateformat
            if(typeof(boardParams.searchParams) !== 'undefined' && typeof(boardParams.searchParams.searchToAddDt) !== 'undefined') {
                let date = boardParams.searchParams.searchToAddDt;
                return moment(date, mFormat).toDate();

            } else {
                return null;
            }
        }
    },
    components: {
        'category-combobox' : CategoryComboBox
    },
    watch: {
        searchPrdCategory2(category2) {
            if(!StringUtil.isNull(category2) && this.isSymptom) {
                this.changeSearchSymptom()
                    .then((res) => {
                        if(res.data.result.length > 0) {
                            let dataList = this.reworkCode(res.data.result);
                            this.searchSYMPTOM_TYPEList = dataList, this.selSymptomType = '';
                            this.searchSYMPTOM_TYPE1List = [], this.selSymptomType1 = '';
                        }
                    });

            } else if(StringUtil.isNull(category2) && this.isSymptom) {
                this.searchSYMPTOM_TYPEList = [], this.selSymptomType = '';
                this.searchSYMPTOM_TYPE1List = [], this.selSymptomType1 = '';
            }
        },
        quickCategoryList(list) {
            this.quickCategoryList = list;
        }
    },
    methods: {
        ...mapActions([ 'setParams' ]),
        setSearchCondition(condition) {
            if(condition !== null) {
                this.condition = condition;
                this.setSearchSymptom(condition.MENU_GROUP_DETAIL_CD);
                this.setSearchGuideDefect(condition.MENU_GROUP_DETAIL_CD);
            }
        },
        // 증상 콤보박스 사용 여부
        setSearchSymptom(menuGroupDetailCd) {
            // Service Bulletin, Repair Tip, Call Guide, Repeated Repair Tip => isSymptom true
            if(menuGroupDetailCd !== null) {
                if(_.includes(SYMPTOM_GROUP_CD, menuGroupDetailCd)) {
                    this.isSymptom = true;

                } else {
                    this.isSymptom = false;
                }

            } else {
                this.isSymptom = false;
            }
        },
        // Guide / Defect 사용 여부
        setSearchGuideDefect(menuGroupDetailCd) {
            // Service Bulletin => isGuideDefect true
            if(menuGroupDetailCd !== null) {
                if(_.includes(GUIDE_DEFECT_GROUP_CD, menuGroupDetailCd)) {
                    this.isGuideDefect = true;

                } else {
                    this.isGuideDefect = false;
                }

            } else {
                this.isGuideDefect = false;
            }
        },
        // watch 를 통해 category3 data 체크
        async changeSearchSymptom(codeCategoryId = 0, categoryId = 'SYMPTOM_TYPE', symptomType = '', symptom1 = '') {
            if(!StringUtil.isNull(this.searchPrdCategory2)) {
                return await fetchSymptomList(categoryId, this.searchPrdCategory2, symptomType, symptom1);
            }

            return [];
        },
        // 증상 콤보 박스 변경
        changeSymptomType(e) {
            let comboValue = document.getElementById(e.target.id) ? StringUtil.getComboboxValue(e.target.id) : "";
            if(comboValue == "") {
                this.searchSYMPTOM_TYPE1List = [], this.selSymptomType1 = '';

            } else {
                this.changeSearchSymptom('', "SYMPTOM_TYPE1", comboValue).then(data => {
                    let dataList = this.reworkCode(data.data.result);
                    this.selSymptomType1 = '';
                    this.searchSYMPTOM_TYPE1List = dataList;
                });
            }
        },
        reworkCode(codeObj) {
            let codeList = [];
            for(let i = 0; i < codeObj.length; i++) {
                let key = 'code' + String(i);
                codeList.push(codeObj[key]);
            }

            return codeList;
        },
        /**
         * category data setting
         */
        setCategoryParam(val) {
            // Vue.$log.info("▶ KnowledgeSearch.vue setCategoryParam => ", val);
            this.searchPrdCategory1 = val.searchPRD_CATEGORY_CD1;
            this.searchPrdCategory2 = val.searchPRD_CATEGORY_CD2;
            this.searchPrdCategory3 = val.searchPRD_CATEGORY_CD3;
        },
        setQuickCategory(cat1, cat2, cat3) {
            let catForm = {
                searchPRD_CATEGORY_CD1: cat1,
                searchPRD_CATEGORY_CD2: cat2,
                searchPRD_CATEGORY_CD3: cat3
            };

            // Call CategoryComboBox.vue setQuickCategoryParam method
            EventBus.$emit('quick-category', catForm);
        },
        setRangeDate(params) {
            let mFormat = localStorage.getItem('mDateFormat');
            let monthPoint = mFormat.indexOf('MM'), dayPoint = mFormat.indexOf('DD'), yearPoint = mFormat.indexOf('YYYY');
            Vue.$log.info("▶ KnowledgeSearch.vue setRangeDate", params.searchFromAddDt, params.searchToAddDt, mFormat);

            if(!StringUtil.isNull(this.rangePicker) && !StringUtil.isNull(params.searchFromAddDt)) {
                let date = params.searchFromAddDt;
                this.rangePicker.setStartDate( moment(date, mFormat).toDate() );
            };

            if(!StringUtil.isNull(this.rangePicker) && !StringUtil.isNull(params.searchToAddDt)) {
                let date = params.searchToAddDt;
                this.rangePicker.setEndDate( moment(date, mFormat).toDate() );
            };
        },
        // Search Parameter setting
        setSearchParameter() {
            let that = this;
            if(!StringUtil.isNull(this.selectedModel) && this.selectedModel.length < 3) {
                return { success: false, msg: 'FIELD.PLACEHOLDER.KNOWLEDGE.SEARCH' };

            } else {
                // 검색 시, Search Parameter 를 vuex store에 저장한다.
                let storeParams = this.storeParams;
                let boardParams = storeParams['boardParams'] || [];
                let boardIdx = boardParams.length > 0 ? _.findIndex(boardParams, function(b){ return b.boardId == that.boardId; }) : null;

                if(boardIdx < 0){
                    boardParams.push({
                        boardId: this.boardId,
                        searchParams: this.setSearchParamWithoutBoardId()
                    });

                } else {
                    if(boardIdx == null) boardIdx = boardParams.length;
                    boardParams[boardIdx] = {
                        boardId: this.boardId,
                        searchParams: this.setSearchParamWithoutBoardId()
                    };
                }

                storeParams['boardParams'] = boardParams;
                this.setParams(storeParams);

                return Object.assign({ success: true, BOARD_ID: this.boardId }, this.setSearchParamWithoutBoardId());
            }
        },
        // Search parameter setting without boardId
        setSearchParamWithoutBoardId() {
            let mFormat = moment().toMomentFormatString(localStorage.getItem('dateFormat') || 'MM.dd.yyyy');
            if(!StringUtil.isNull(this.selectedModel)) {
                // Model code 는 검색 시 uppercase 처리
                this.selectedModel = this.selectedModel.toUpperCase();
            }

            return {
                searchFromAddDt: this.rangePicker.getStartDate() ? moment(this.rangePicker.getStartDate()).formatWithJDF(mFormat) : '',
                searchToAddDt: this.rangePicker.getEndDate() ? moment(this.rangePicker.getEndDate()).formatWithJDF(mFormat) : '',
                searchPRD_CATEGORY_CD1: this.searchPrdCategory1,
                searchPRD_CATEGORY_CD2: this.searchPrdCategory2,
                searchPRD_CATEGORY_CD3: this.searchPrdCategory3,
                selectedModel: this.selectedModel || '',
                multi: this.multi || 'N',
                searchSYMPTOM_TYPE: this.selSymptomType,
                searchSYMPTOM_TYPE1: this.selSymptomType1,
                guide_type: this.isGuideDefect ? document.getElementById('guideType').value || '' : '',
                defect_type: this.isGuideDefect ? document.getElementById('defectType').value || '' : '',
//                 sb_guide_type: this.isGuideDefect ? document.getElementById('sbGuideType').value || '' : '',
//                 sb_defect_type: this.isGuideDefect ? document.getElementById('sbDefectType').value || '' : '',
                searchTitle: this.searchTitle || '',
                ORDER_COLUMN: this.ORDER_COLUMN || '',
                ORDER_ASC: this.ORDER_ASC || '',
                page: this.getPageNo
            };
        },
        setQuickCategoryList(qc) {
            if(qc.length > 0) {
                this.quickCategoryList = qc;
            }
        },
        // 조회
        handleSearch() {
            let params = this.setSearchParameter();
            if(!params.success) {
                try{
                    return SDLUtil.alert(params.msg);
                } catch(e) {
                    Vue.$log.error(e);
                    return SDLUtil.alert(params.msg);
                }

            } else {
                EventBus.$emit('knowledge-grid-search', params);   // Call KnowledgeListGrid.vue > loadData method
            }
        },
        // 페이지 조회
        handlePageSearch(pageNo = 1){
            if(!StringUtil.isNull(pageNo)) {
                this.pageNo = pageNo;
                this.handleSearch();
                this.$emit('current-page', Number(pageNo));

            } else {
                Vue.$log.warn('Page no is null');
            }
        },
        // 정렬 조회 - 정렬로 조회하는 경우, 페이지를 1로 초기화 한다.
        handleSortSearch(sortObj) {
            if(!StringUtil.isNull(sortObj.orderColName)) {
                this.ORDER_COLUMN = sortObj.orderColName;
                this.ORDER_ASC = sortObj.ascending ? "ASC" : "DESC";
            } else {
                this.ORDER_COLUMN = '';
                this.ORDER_ASC = '';
            }

            this.handlePageSearch(1);
        },
        // 모델코드 선택
        handleSelectModel(model = '') {
            if(!StringUtil.isNull(model)) {
                this.setQuickCategory('', '', '');
                this.selectedModel = model.modelNm;

            } else {
                this.selectedModel = '';
            }
        },
        // 재조회
        reSearch(pageNo) {
            const boardParams = SDLUtil.getBoardSearchParams(this.getBoardId);
            this.setCategoryParam(boardParams.searchParams);
            this.setRangeDate(boardParams.searchParams);
            this.selectedModel = boardParams.searchParams.selectedModel || '';
            this.searchTitle = boardParams.searchParams.searchTitle || '';
            this.pageNo = pageNo;
            this.handlePageSearch(pageNo);
        },

        excelDownload() {
            SDLUtil.confirm({
                msg: 'Download the Excel file?<br>Only up to 5000 rows of data will be exported.',
                onOkEvt: () => {
                    SDLUtil.showLoadingBar(true);
                    const mFormat = localStorage.getItem('mDateFormat');

                    let params = this.setSearchParameter();
                    if (!params.success) {
                        try{
                            return SDLUtil.alert(params.msg);
                        } catch(e) {
                            Vue.$log.error(e);
                            return SDLUtil.alert(params.msg);
                        }
                    }

                    return axios
                        .post(
                            `${SDLUtil.API_URL}/basis/knowledge/knowledgeListExcel.skp`,
                            qs.stringify(params),
                        )
                        .then(resp => {
                            SDLUtil.showLoadingBar(false);
                            if (resp.data.EXCEL_FILES.length > 0) {
                                SDLUtil.show(
                                    ExcelDownloadPopup,
                                    {
                                        title: SDLUtil.getMsgProp('TITLE.EXCEL.DOWNLOAD'),
                                        excelFiles: resp.data.excelFiles,
                                    },
                                    {
                                        height: 'auto',
                                    },
                                );
                            } else {
                                SDLUtil.alert({
                                    msg: 'Nothing to export.',
                                });
                            }
                            SDLUtil.showLoadingBar(false);
                        })
                        .catch(err => {
                            Vue.$log.error(err);
                            SDLUtil.errorAlert(err);
                            SDLUtil.showLoadingBar(false);
                        });
                },
            });
        },
    },
    created() {
        if(this.getCondition !== {}) { this.setSearchCondition(this.getCondition); }
        // EventBus 를 통해 search component 에서 넘어온 formData를 처리
        EventBus.$on('knowledge-page-search',   pageNo      => { this.handlePageSearch(pageNo); });
        EventBus.$on('knowledge-sort-search',   sortForm    => { this.handleSortSearch(sortForm); });
        EventBus.$on('select-recent-model',     model       => { this.handleSelectModel(model); });
        EventBus.$on('mobile-category',         catList     => { this.setQuickCategoryList(catList); });

        EventBus.$on('knowledge-excel-download', pageNo => { this.excelDownload(pageNo); });

        // 20.08.04 - SVC Tool 일 경우 (boardId: 25480) 검색 기간을 5년으로 설정
        this.searchRange = (this.boardId === '25480') ? -5 : -3;
    },
    mounted() {
        // 범위 지정 Datepicker 로 변경
        this.rangePicker = DatePicker.createRangeWithOpener(
            'from-picker-container', 'fromDate', 'icoFromDate',
            'to-picker-container', 'toDate', 'icoToDate',
            { type: 'date', locale: 'en', showToday: false },
            StringUtil.nvl(this.getFromDate, (new moment()).add(this.searchRange, 'years').toDate()),
            StringUtil.nvl(this.getToDate, (new moment()).toDate())
        );

        this.$nextTick(() => {
            if(this.getReSearch === 'Y') {
                const pageNo = this.$route.query.page || 1;
                this.selectedModel = this.$route.query.selectedModel;
                this.searchTitle = this.$route.query.searchTitle;
                this.multi = this.$route.query.multi;
                this.reSearch(pageNo);
            }
        });
    },
    beforeDestroy(){
        // [필수] EventBus 를 통해 등록된 이벤트는 컴포넌트 종료시 반드시 종료한다.
        EventBus.$off('knowledge-page-search');
        EventBus.$off('knowledge-sort-search');
        EventBus.$off('select-recent-model');
        EventBus.$off('mobile-category');

        EventBus.$off('knowledge-excel-download');
    }
};
</script>

<style>
.tui-datepicker {
    z-index: 9999;
    border: 1px solid #aaa;
    background-color: white;
    position: absolute;
}
.bg_white {
    background-color: white !important;
}
</style>


// WEBPACK FOOTER //
// src/skpComponents/view/basis/knowledge/KnowledgeSearch.vue